import script from "./ExpenseTrendChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpenseTrendChart.vue?vue&type=script&setup=true&lang=ts"

import "./ExpenseTrendChart.vue?vue&type=style&index=0&id=122c770a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122c770a"]])

export default __exports__